export default __webpack_public_path__ + "static/media/icon-admin-active.7f9b3b61.svg";